(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sp-bundle-picker"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSpBundle(root) {
      if (root.dataset.spBundleInit === '1') return;
      root.dataset.spBundleInit = '1';

      const bundleHandle = root.dataset.bundleHandle;
      const discountPercent = parseFloat(root.dataset.discountPercent) || 0;
      const discountActive = root.dataset.discountActive === 'true';
      const currency = root.dataset.currency || 'EUR';
      const locale = root.dataset.locale || navigator.language || 'it-IT';
      const t = {
        add: root.dataset.tAdd || 'Aggiungi bundle al carrello',
        adding: root.dataset.tAdding || 'Aggiungo al carrello…',
        noColors: root.dataset.tNoColors || 'Nessun colore disponibile in tutti i pezzi.'
      };

      const submitBtn = root.querySelector('[data-bundle-submit]');
      const submitLabel = root.querySelector('[data-bundle-submit-label]');
      const errorEl = root.querySelector('[data-bundle-error]');
      const subtotalEl = root.querySelector('[data-bundle-subtotal]');
      const discountEl = root.querySelector('[data-bundle-discount]');
      const finalEl = root.querySelector('[data-bundle-final]');
      const colorPicker = root.querySelector('[data-shared-color-picker]');
      const colorValueLabel = root.querySelector('[data-shared-color-value]');

      let parentMap = {};
      const parentMapEl = root.querySelector('[data-bundle-parent-map]');
      if (parentMapEl) {
        try { parentMap = JSON.parse(parentMapEl.textContent.trim()); } catch (e) { parentMap = {}; }
      }

      function formatMoney(cents) {
        try { return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency }); }
        catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
      }

      function prettyColor(raw) {
        if (!raw) return '';
        return raw.split('-').map(function(w) {
          if (!w) return '';
          if (w.toLowerCase() === 'e') return 'e';
          return w.charAt(0).toUpperCase() + w.slice(1);
        }).filter(Boolean).join(' ');
      }

      function normalizeUrl(u) {
        if (!u) return u;
        if (u.indexOf('//') === 0) return 'https:' + u;
        return u;
      }

      function fileKey(u) {
        return (u.split('?')[0]).toLowerCase().replace(/[\s\-_]+/g, '');
      }

      function colorNeedle(c) {
        return (c || '').toLowerCase().replace(/[\s\-_]+/g, '');
      }

      function variantImageUrl(v) {
        if (v.featured_image && v.featured_image.src) return v.featured_image.src;
        if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
          return v.featured_media.preview_image.src;
        }
        if (typeof v.featured_image === 'string') return v.featured_image;
        return null;
      }

      const components = Array.from(root.querySelectorAll('[data-bundle-component]')).map(function(el) {
        const variants = JSON.parse(el.querySelector('[data-component-variants]').textContent.trim());
        let images = [];
        const imgEl = el.querySelector('[data-component-images]');
        if (imgEl) { try { images = JSON.parse(imgEl.textContent.trim()); } catch (e) { images = []; } }
        const colorPos = el.dataset.colorPosition ? parseInt(el.dataset.colorPosition, 10) : null;
        const sizePos = el.dataset.sizePosition ? parseInt(el.dataset.sizePosition, 10) : null;
        return {
          element: el,
          variants: variants,
          images: images,
          colorPos: colorPos,
          sizePos: sizePos,
          sizePicker: el.querySelector('[data-size-picker]'),
          sizeValueLabel: el.querySelector('[data-selected-size]'),
          priceEl: el.querySelector('[data-component-price]'),
          carousel: {
            track: el.querySelector('[data-carousel-track]'),
            prev: el.querySelector('[data-carousel-prev]'),
            next: el.querySelector('[data-carousel-next]'),
            dots: el.querySelector('[data-carousel-dots]'),
            index: 0,
            count: 0
          },
          selectedSize: null,
          currentVariant: null
        };
      });

      function colorOf(variant, comp) { return comp.colorPos ? variant['option' + comp.colorPos] : null; }
      function sizeOf(variant, comp) { return comp.sizePos ? variant['option' + comp.sizePos] : null; }

      function computeSharedColors() {
        const compsWithColor = components.filter(function(c) { return c.colorPos; });
        if (compsWithColor.length === 0) return [];
        let shared = null;
        compsWithColor.forEach(function(c) {
          const colorsHere = {};
          c.variants.forEach(function(v) {
            if (v.available) colorsHere[colorOf(v, c)] = true;
          });
          const keys = Object.keys(colorsHere);
          if (shared === null) { shared = keys; }
          else { shared = shared.filter(function(k) { return keys.indexOf(k) !== -1; }); }
        });
        return shared || [];
      }

      let selectedColor = null;

      function swatchImageForColor(color) {
        const needle = colorNeedle(color);
        for (let i = 0; i < components.length; i++) {
          const imgs = components[i].images || [];
          for (let j = 0; j < imgs.length; j++) {
            if (fileKey(imgs[j]).indexOf(needle) !== -1) return normalizeUrl(imgs[j]);
          }
        }
        return null;
      }

      function buildColorPicker() {
        const colors = computeSharedColors();
        colorPicker.innerHTML = '';
        if (colors.length === 0) {
          colorPicker.innerHTML = '<p style="font-size:0.8125rem;color:var(--color-danger,#c0392b)">' + t.noColors + '</p>';
          return;
        }
        colors.forEach(function(color, idx) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sp-bundle-swatch';
          btn.dataset.colorValue = color;
          btn.setAttribute('aria-pressed', idx === 0 ? 'true' : 'false');
          btn.setAttribute('aria-label', prettyColor(color));
          btn.title = prettyColor(color);

          const thumb = document.createElement('span');
          thumb.className = 'sp-bundle-swatch__thumb';
          const url = swatchImageForColor(color);
          if (url) {
            thumb.style.backgroundImage = 'url("' + url + '")';
          } else {
            thumb.style.background = 'rgb(var(--color-foreground-rgb) / 12%)';
          }
          btn.appendChild(thumb);

          const label = document.createElement('span');
          label.className = 'sp-bundle-swatch__label';
          label.textContent = prettyColor(color);
          btn.appendChild(label);

          btn.addEventListener('click', function() { selectColor(color); });
          colorPicker.appendChild(btn);
        });
        selectColor(colors[0]);
      }

      function selectColor(color) {
        selectedColor = color;
        colorValueLabel.textContent = prettyColor(color);
        Array.prototype.forEach.call(colorPicker.querySelectorAll('[data-color-value]'), function(b) {
          b.setAttribute('aria-pressed', b.dataset.colorValue === color ? 'true' : 'false');
        });
        components.forEach(function(c) {
          c.selectedSize = null;
          c.sizeValueLabel.textContent = '—';
          buildSizePicker(c);
          updateComponentImage(c);
        });
        refresh();
      }

      function updateComponentImage(comp) {
        const car = comp.carousel;
        if (!car.track) return;

        const needle = colorNeedle(selectedColor);
        let imgs = comp.images.filter(function(u) {
          return needle && fileKey(u).indexOf(needle) !== -1;
        });

        if (imgs.length === 0) {
          for (let i = 0; i < comp.variants.length; i++) {
            const v = comp.variants[i];
            if (colorOf(v, comp) === selectedColor && v.featured_image && v.featured_image.src) {
              imgs = [v.featured_image.src];
              break;
            }
          }
        }
        if (imgs.length === 0) imgs = comp.images.slice();

        car.track.innerHTML = '';
        imgs.forEach(function(u, i) {
          const slide = document.createElement('div');
          slide.className = 'sp-bundle-carousel__slide';
          const img = document.createElement('img');
          img.src = normalizeUrl(u);
          img.loading = i === 0 ? 'eager' : 'lazy';
          img.alt = prettyColor(selectedColor);
          slide.appendChild(img);
          car.track.appendChild(slide);
        });

        car.count = imgs.length;
        car.index = 0;
        const multi = imgs.length > 1;
        if (car.prev) car.prev.hidden = !multi;
        if (car.next) car.next.hidden = !multi;
        buildDots(comp);
        goToSlide(comp, 0);
      }

      function buildDots(comp) {
        const car = comp.carousel;
        if (!car.dots) return;
        car.dots.innerHTML = '';
        if (car.count <= 1) return;
        for (let i = 0; i < car.count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sp-bundle-carousel__dot';
          dot.setAttribute('aria-current', i === car.index ? 'true' : 'false');
          (function(idx) { dot.addEventListener('click', function() { goToSlide(comp, idx); }); })(i);
          car.dots.appendChild(dot);
        }
      }

      function goToSlide(comp, idx) {
        const car = comp.carousel;
        if (car.count === 0) return;
        if (idx < 0) idx = car.count - 1;
        if (idx >= car.count) idx = 0;
        car.index = idx;
        const slide = car.track.children[idx];
        if (slide) car.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        if (car.dots) {
          Array.prototype.forEach.call(car.dots.children, function(d, i) {
            d.setAttribute('aria-current', i === idx ? 'true' : 'false');
          });
        }
      }

      function buildSizePicker(comp) {
        comp.sizePicker.innerHTML = '';
        if (!comp.sizePos) return;
        const seen = {};
        const sizes = [];
        comp.variants.forEach(function(v) {
          if (comp.colorPos && colorOf(v, comp) !== selectedColor) return;
          const s = sizeOf(v, comp);
          if (s != null && !seen[s]) { seen[s] = true; sizes.push(s); }
        });
        sizes.forEach(function(size) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sp-bundle-opt-btn';
          btn.dataset.sizeValue = size;
          btn.setAttribute('aria-pressed', 'false');
          btn.textContent = size;
          const available = comp.variants.some(function(v) {
            const colorOk = !comp.colorPos || colorOf(v, comp) === selectedColor;
            return colorOk && sizeOf(v, comp) === size && v.available;
          });
          if (!available) btn.dataset.unavailable = 'true';
          btn.addEventListener('click', function() {
            if (btn.dataset.unavailable === 'true') return;
            selectSize(comp, size);
          });
          comp.sizePicker.appendChild(btn);
        });
      }

      function selectSize(comp, size) {
        comp.selectedSize = size;
        comp.sizeValueLabel.textContent = size;
        Array.prototype.forEach.call(comp.sizePicker.querySelectorAll('[data-size-value]'), function(b) {
          b.setAttribute('aria-pressed', b.dataset.sizeValue === size ? 'true' : 'false');
        });
        refresh();
      }

      function resolveVariant(comp) {
        comp.currentVariant = comp.variants.find(function(v) {
          const colorOk = !comp.colorPos || colorOf(v, comp) === selectedColor;
          const sizeOk = !comp.sizePos || sizeOf(v, comp) === comp.selectedSize;
          return colorOk && sizeOk;
        }) || null;
      }

      function refresh() {
        let allValid = true;
        let subtotal = 0;
        components.forEach(function(c) {
          resolveVariant(c);
          if (c.currentVariant && c.currentVariant.available) {
            subtotal += c.currentVariant.price;
            if (c.priceEl) c.priceEl.textContent = formatMoney(c.currentVariant.price);
          } else {
            allValid = false;
          }
        });
        const effectiveDiscount = discountActive ? discountPercent : 0;
        const discountAmount = subtotal * (effectiveDiscount / 100);
        subtotalEl.textContent = formatMoney(subtotal);
        discountEl.textContent = '−' + formatMoney(discountAmount);
        finalEl.textContent = formatMoney(subtotal - discountAmount);

        // Nascondi riga sconto se disattivato
        const discountRow = root.querySelector('.sp-bundle-picker__price-row--discount');
        if (discountRow) discountRow.style.display = discountActive ? '' : 'none';
        if (allValid && subtotal > 0) {
          submitBtn.disabled = false;
          errorEl.hidden = true;
        } else {
          submitBtn.disabled = true;
        }
      }


      function parentVariantIdForColor(color) {
        if (!parentMap || !color) return '';
        if (parentMap[color]) return parentMap[color];
        const lc = color.toLowerCase();
        const keys = Object.keys(parentMap);
        for (let i = 0; i < keys.length; i++) {
          if (keys[i].toLowerCase() === lc) return parentMap[keys[i]];
        }
        return '';
      }

      components.forEach(function(comp) {
        const car = comp.carousel;
        if (car.prev) car.prev.addEventListener('click', function() { goToSlide(comp, car.index - 1); });
        if (car.next) car.next.addEventListener('click', function() { goToSlide(comp, car.index + 1); });
        if (car.track) {
          car.track.addEventListener('scroll', function() {
            const slideW = car.track.clientWidth || 1;
            const idx = Math.round(car.track.scrollLeft / slideW);
            if (idx !== car.index && idx >= 0 && idx < car.count) {
              car.index = idx;
              if (car.dots) {
                Array.prototype.forEach.call(car.dots.children, function(d, i) {
                  d.setAttribute('aria-current', i === idx ? 'true' : 'false');
                });
              }
            }
          });
        }
      });

      submitBtn.addEventListener('click', function() {
        submitBtn.disabled = true;
        submitLabel.textContent = t.adding;
        errorEl.hidden = true;

        var parentId = parentVariantIdForColor(selectedColor);
        var bundleInstance = Math.random().toString(36).slice(2) + Date.now().toString(36);
        var fullPrice = components.reduce(function(sum, c) {
          return sum + (c.currentVariant ? c.currentVariant.price : 0);
        }, 0);
        var baseProps = {
          '_bundle_id': bundleHandle,
          '_bundle_size': String(components.length),
          '_bundle_color': prettyColor(selectedColor),
          '_bundle_instance': bundleInstance,
          '_bundle_full_price': String(fullPrice)
        };
        if (parentId) baseProps['_bundle_parent'] = parentId;

        var items = components.map(function(c, idx) {
          var props = Object.assign({}, baseProps, { '_bundle_role': String(idx) });
          return { id: c.currentVariant.id, quantity: 1, properties: props };
        });

        var body = { items: items };

        // Raccogli section IDs per il rendering del drawer
        var cartItemsComponents = document.querySelectorAll('cart-items-component');
        var sectionIds = [];
        cartItemsComponents.forEach(function(item) {
          if (item.dataset && item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });
        if (sectionIds.length) body.sections = sectionIds.join(',');

        // Usa CartLinesUpdateEvent nativo di Horizon per aggiornare e aprire il drawer
        import('@shopify/events').then(function(events) {
          var CartLinesUpdateEvent = events.CartLinesUpdateEvent;
          var deferred = CartLinesUpdateEvent.createPromise();

          root.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map(function(item) {
              return { merchandiseId: String(item.id), quantity: item.quantity };
            }),
            promise: deferred.promise
          }));

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function(res) {
            if (!res.ok) {
              return res.json().catch(function() { return {}; }).then(function(err) {
                throw new Error(err.description || err.message || 'Errore aggiungendo il bundle al carrello.');
              });
            }
            return res.json();
          }).then(function(addResponse) {
            // Refresh cart come fa il tema nativo
            var cartItems = document.querySelector('cart-items-component');
            var cartPromise;
            if (cartItems && typeof cartItems.fetchCartData === 'function') {
              cartPromise = cartItems.fetchCartData();
            } else {
              cartPromise = fetch(window.Shopify.routes.root + 'cart.js', {
                headers: { 'Accept': 'application/json' }
              }).then(function(r) { return r.json(); });
            }
            return cartPromise.then(function(cart) {
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items,
                  source: 'product-form-component',
                  sourceId: 'sp-bundle-picker',
                  itemCount: items.length,
                  sections: addResponse.sections || {},
                  didError: false
                }
              });
            });
          }).then(function() {
            submitLabel.textContent = t.add;
            submitBtn.disabled = false;
          }).catch(function(e) {
            errorEl.textContent = e.message;
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitLabel.textContent = t.add;
          });
        }).catch(function() {
          // Fallback se import fallisce: add + redirect a /cart
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          }).then(function() {
            window.location.href = window.Shopify.routes.root + 'cart';
          });
        });
      });

      buildColorPicker();
    }

    function initAll() {
      document.querySelectorAll('[data-sp-bundle]').forEach(initSpBundle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Riprova al load completo (immagini, async theme renders)
    window.addEventListener('load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
